import {
    DELETE_DISCOUNT_CODE,
    DELETE_DISCOUNT_CODE_FAILURE,
    DELETE_DISCOUNT_CODE_SUCCESS,
} from 'store/actions/types';

export const deleteDiscountCode = (payload) => {
    return {
        type: DELETE_DISCOUNT_CODE,
        payload: payload,
    };
};

export const deleteDiscountCodeFailure = (error) => {
    return {
        type: DELETE_DISCOUNT_CODE_FAILURE,
        error: error,
    };
};

export const deleteDiscountCodeSuccess = (payload) => {
    return {
        type: DELETE_DISCOUNT_CODE_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discountCodes/deleteDiscountCodes.js